export enum OrganizationPermissionEnum {
  isSection841Available = 'isSection841Available',
  isRolloverAvailable = 'isRolloverAvailable',
  isRRQAvailable = 'isRRQAvailable',
  isClientQuestionnaireAvailable = 'isClientQuestionnaireAvailable',
  isSalaryDividendAvailable = 'isSalaryDividendAvailable',
  isRrspAvailable = 'isRrspAvailable',
}
